import {SET_TEST_CANDIDATE_GRADE} from '../actions/index';
export default function setCandidateGrade(state = null, action) {
	switch (action.type) {
		case SET_TEST_CANDIDATE_GRADE:
			return action.grade;
		default:
			return state;
	}
}
